import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';

import { debounceTime, distinctUntilChanged, Observable, Subscriber, Subscription } from 'rxjs';
import { County } from 'src/app/model/county';
import { Region } from 'src/app/model/region.model';
import { HelperService } from 'src/app/service/helper.service';
import { CountyEntityService } from '../../service/county-entity.service';

@Component({
    selector: 'county-dropdown',
    templateUrl: './county-dropdown.component.html',
    styleUrls: ['./county-dropdown.component.scss']
})
export class CountyDropdownComponent implements OnInit {
    @Input() selectCountyIds: number[] = [];
    @Input() isMultiple: boolean = true;
    @Input() disableAutoComplete: boolean = false;
    @Input('reset') reset: boolean;
    @Input() required: boolean = false;
    @Input('disabled') disabled: boolean;
    @Input('customLabel') customLabel: string;
    @Output() eventEmitterCounty = new EventEmitter<County[]>();

    @ViewChild('filterRef') filterRef: ElementRef;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSelect) matSelect: MatSelect;

    fieldLabel: string;
    countyForm: UntypedFormGroup;
    countyIds: number[] = [];
    selectedCountyIds: number[] = [];

    selectedCountyName: string | undefined;
    filteredCounties: County[] = [];
    filteredCountiesShow: County[] = [];

    regions: Region[] = [];
    counties: County[] = [];
    allCounties: County[] = [];

    userRegion: Region = new Region();
    userRegionLoaded: boolean = false;

    loaded$: Observable<boolean>;
    isLoading: boolean = false;
    changed: boolean = true;

    backupScreenIds: number[] = [];

    //////

    subs: Subscription[] = [];

    pageIndex: number = 0;
    pageSize: number = 5;

    constructor(private fb: UntypedFormBuilder, private countyService: CountyEntityService, private helperService: HelperService) {
        this.countyForm = this.fb.group({
            countySelect: [''],
            filter: ['']
        });

        this.loaded$ = countyService.loaded$;
        let loadedSub = this.loaded$?.subscribe((loaded) => {
            if (!loaded || this.disabled) {
                this.countySelect.disable();
            } else {
                this.countySelect.enable();
            }
        });
        this.subs.push(loadedSub);
    }

    subscribers() {
        let countyEntitiesSub = this.countyService.entities$.subscribe((counties: County[]) => {
            this.allCounties = counties;
            this.countyIds = this.allCounties.length > 0 ? this.allCounties.map((county) => county.ID!) : [];
            //console.log('countyIds found:');
            //console.log(this.countyIds);
            this.changed = true;

            this.loadData(true);
        });
        this.subs.push(countyEntitiesSub);

        let lstUserProfileSub = this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
            this.userRegion = userRegion[0];
        });
        this.subs.push(lstUserProfileSub);

        let selectedRegionsSub = this.helperService.selectedRegions$.subscribe((selectedRegions: Region[]) => {
            if (selectedRegions?.length <= 0) {
                let lstUserProfileSub2 = this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
                    this.changed = true;
                    this.regions = userRegion;
                    this.loadData(true);
                });

                this.subs.push(lstUserProfileSub2);
            } else {
                this.changed = true;
                this.regions = selectedRegions;
                this.loadData(true);
            }
        });
        this.subs.push(selectedRegionsSub);

        let filterInputSub = this.filterInput!.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((value: string) => {
            if (value.length === 0) {
                this.filteredCounties = this.counties;
            } else {
                this.filteredCounties = this.counties.filter((county) => county.COUNTY_NAME!.toLowerCase().includes(value.toLowerCase()));
                this.onPageChange({ pageIndex: 0, pageSize: this.pageSize });
            }
        });
        this.subs.push(filterInputSub);
    }

    emitSelect(countyIds: number[]) {
        let output: County[] = [];
        this.selectedCountyIds = Array.from(new Set(this.selectedCountyIds.concat(countyIds)));

        if (countyIds.length > 0) {
            this.counties.forEach((filteredCounty) => {
                countyIds.forEach((countyId) => {
                    if (countyId == filteredCounty.ID) {
                        output.push(filteredCounty);
                    }
                });
            });
        }

        this.selectedCountyName = output[0]?.COUNTY_NAME!;
        this.helperService.setSelectedCountyListObject(output);
        this.filterInput?.patchValue('');
        output[0] ? this.goToPage(output[0].ID!) : this.goToPage(0);
        //Emits the code to the subscriber.
        this.eventEmitterCounty.emit(output);
    }

    ngOnInit(): void {
        if (this.customLabel) {
            this.fieldLabel = this.customLabel;
        } else {
            this.fieldLabel = 'County';
        }

        this.subscribers();

        // let initLoadedSub = this.loaded$?.subscribe((loaded) => {
        //     if (loaded) {
        //         setTimeout(() => {
        //             if (this.selectCountyIds.length > 0) {
        //                 this.select(this.selectCountyIds);

        //                 this.emitSelect(this.selectCountyIds);
        //             } else {
        //                 this.onPageChange({ pageIndex: 0, pageSize: this.pageSize });
        //             }

        //             this.selectCountyIds = [];
        //             initLoadedSub.unsubscribe();
        //         }, 500);
        //     }
        // });
        // this.subs.push(initLoadedSub);
    }

    ngOnDestroy() {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.reset) {
            this.deSelectAll();
        }

        if (this.disabled) {
            this.countySelect.disable();
        } else {
            this.countySelect.enable();
        }

        if (changes['selectCountyIds']) {
            if (this.selectCountyIds.length > 0) {
                this.select(this.selectCountyIds);

                this.emitSelect(this.selectCountyIds);
            } else {
                this.onPageChange({ pageIndex: 0, pageSize: this.pageSize });
            }

            this.selectCountyIds = [];
        }
    }

    loadData(open: any) {
        if (open) {
            this.filterRef ? this.filterRef.nativeElement.focus() : null;
            if (!this.changed) return;

            this.counties = [];
            this.isLoading = true;
            this.countySelect.disable();
            this.changed = false;
            this.filterInput!.patchValue('');

            let workingSchoolDistricts = this.allCounties;

            if (this.regions.length > 0) {
                workingSchoolDistricts = workingSchoolDistricts.filter((county) => this.regions.find((region) => region.ID === county.REGION?.ID));
            }

            this.counties = Array.from(new Set(workingSchoolDistricts));
            this.counties.sort((a, b) => a.COUNTY_NAME!.localeCompare(b.COUNTY_NAME!));
            this.filteredCounties = this.counties;

            if (this.counties.length === 1 && !this.disableAutoComplete) {
                this.countySelect.patchValue([]);
                this.selectAll();
                this.emitSelect(this.selectedCountyIds);
            } else {
                this.select(this.selectedCountyIds);
                this.emitSelect(this.selectedCountyIds);
            }
            if (!this.disabled) {
                this.countySelect.enable();
            }
            this.changed = false;
            this.isLoading = false;
        } else {
            this.select(this.selectedCountyIds);
            this.emitSelect(this.selectedCountyIds);
        }
    }

    removeDuplicateIDs(arr: Array<any>): Array<any> {
        arr = arr.filter((value, index, self) => index === self.findIndex((t) => t.place === value.place && t.ID === value.ID));

        return arr;
    }

    select(selection: any) {
        // Get current page
        this.filteredCounties = this.counties;

        if (this.isMultiple) {
            // Remove all selections in current page
            let currentPageIds = this.filteredCountiesShow.map((show) => show.ID);
            this.selectedCountyIds = this.selectedCountyIds.filter((selectedCountyId) => !currentPageIds.includes(selectedCountyId));

            // Add current selection to total array
            this.selectedCountyIds = Array.from(new Set(this.selectedCountyIds.concat(selection)));

            // Remove all IDs that are not in available counties
            let filteredCounties = this.filteredCounties.map((filteredCounty) => filteredCounty.ID);
            this.selectedCountyIds = this.selectedCountyIds.filter((selectedCountyId) => filteredCounties.includes(selectedCountyId));

            this.countySelect.patchValue(this.selectedCountyIds);
        } else {
            if (Array.isArray(selection)) {
                this.countySelect.patchValue(selection[0]);
                this.selectedCountyIds = selection;
            } else {
                this.countySelect.patchValue(selection);
                this.selectedCountyIds = [selection];
            }

            this.goToPage(this.countySelect.value);
            this.emitSelect(this.selectedCountyIds);
        }
    }

    selectAll() {
        //console.log('calling selectAll');
        let selected = this.countySelect.value; // Currently selected
        if (this.isMultiple) {
            selected = Array.isArray(selected) ? selected : [];
            Array.from(new Set((this.selectedCountyIds = selected.concat(this.filteredCounties.map((county) => county.ID!))))); // Select all filtered (if any filter)
            this.countySelect.patchValue(this.selectedCountyIds);
        } else {
            this.selectedCountyIds = this.filteredCounties.map((county) => county.ID!);
            this.countySelect.patchValue(this.selectedCountyIds[0]);
        }
    }

    deSelectAll() {
        //console.log('calling deSelectAll');
        this.reset = false;
        this.countySelect.patchValue([]);
        this.selectedCountyIds = [];
        this.filterInput?.patchValue('');
        this.emitSelect([]);
    }

    close() {
        this.matSelect.close();
    }

    get countySelect(): any {
        return this.countyForm.get('countySelect');
    }
    get filterInput(): AbstractControl | null {
        return this.countyForm.get('filter');
    }

    onPageChange($event: any) {
        $event.pageIndex = $event.pageIndex < 0 ? 0 : $event.pageIndex;

        this.pageIndex = $event.pageIndex;
        this.pageSize = $event.pageSize;

        this.filteredCountiesShow = this.filteredCounties.slice($event.pageIndex * $event.pageSize, $event.pageIndex * $event.pageSize + $event.pageSize);
    }

    goToPage(id: number) {
        let index = this.filteredCounties.findIndex((filteredCounty) => filteredCounty.ID === id);
        let pageIndex = Math.floor(index / this.pageSize);

        if (this.paginator) {
            this.paginator.pageIndex = pageIndex;
        }
        this.onPageChange({ pageIndex: pageIndex, pageSize: this.pageSize });
    }
}
